import React from "react";
import About from "./About";
import Contact from "./Contact";
import Projects from "./Projects";


const name = "Steven Musembi";
const title = "Front-End Developer";
export default function Home(){
    return(
    <div>
    <About  name= {name} title={title} />
    <Projects />
    <Contact />
    </div>
    )
}